module.exports = __webpack_public_path__ + "static/img/logo_index_m.bd247b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/logo_index_m.png
// module id = 36Lf
// module chunks = 1 3 9 10 17 18